import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import numeral from 'numeral';
import _ from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
// import RouteCollection, { Link } from '@bd/bdcore-named-routes';
import { GoogleMapUrl, Image } from '@bd/bdcore-utilities';
// import { getPlanRouteProps } from '@bd/bdcore-data/build/Plans/selectors';
// import { getCommunityRouteProps } from '@bd/bdcore-data/build/Communities/selectors';

function HomeCard({ home }) {
  return (
    <div className="card Home">
      <Link name="home-detail" home={home}>
        <Image
          className="card-img-top"
          src={_.get(home, 'photos[0].contentUrl', '')}
          alt={_.get(home, 'streetAddress', '')}
          width={450}
          height={300}
          exact
        />
        {
          home.headline &&
          <div className="HomeCard_headline">{home.headline}</div>
        }
      </Link>
      <div className="card-body">
        <div className="row no-gutters">
          <div className="col-10">
            <Link name="home-detail" home={home}>
              <h4 className="address">
                {home.address.streetAddress}<br />
                <span>{home.address.addressLocality}, {home.address.addressRegion}</span>
              </h4>
            </Link>
          </div>
          <div className="col-2 map-link">
            <a href={GoogleMapUrl(home, 18)} rel="noopener noreferrer" target="_blank">
              <img src="/images/icon-map-pin-charcoal.svg" alt="Map Pin" />
            </a>
          </div>
        </div>
      </div>
      <ul className="list-group">
        <li className="list-group-item">
          <div className="row align-items-center">
            <div className="col-12">
              <span className="price">{ numeral(home.price).format('$0,0') }</span>
            </div>
          </div>
        </li>
        { (home.stories > 0 || home.garages > 0) &&
          <li className="list-group-item inline">
            { home.stories > 0 && <div>Stories: {home.stories}</div> }
            { home.garages > 0 && <div>Garage: {home.garages}-Car</div> }
          </li>
        }
        <li className="list-group-item">
          <div className="row text-center details">
            <div className="col">
              <img src="/images/icon-beds-blue.svg" alt="Bed Icon" />
              <div><span>{home.beds}</span><br />Beds</div>
            </div>
            <div className="col">
              <img src="/images/icon-baths-blue.svg" alt="Bath Icon" />
              <div>
                <strong>{_.get(home, 'bathsFull')} {_.get(home, 'bathsHalf', 0) > 0 && '.5'}</strong><br />Baths
              </div>
            </div>
            <div className="col">
              <img src="/images/icon-sqft-blue.svg" alt="Square Feet Icon" /><br />
              <div><span>{ numeral(home.sqft).format('0,0') }</span><br />SQFT</div>
            </div>
          </div>
        </li>
        <li className="list-group-item">
          {/* {
            _.get(community, 'name') &&
            <div>Community: <Link name="community-detail" commu
            nity={community}>{_.get(community, 'name')}</Link></div>
          }
          {
            _.get(plan, 'name') &&
            <div>Floor Plan: <Link name="plan-detail" plan={plan}>{_.get(plan, 'name')}</Link></div>
          } */}
          {/* {
            RouteCollection.hasRoute('community-detail') &&
            community &&
            <div>Community: <Link name="community-detail" param
            s={getCommunityRouteProps(community)}>{_.get(community, 'name')}</Link></div>
          }
          {
            RouteCollection.hasRoute('plan-detail') &&
            home.plan &&
            plan &&
            <div>Floor Plan: <Link name="plan-detail" params={
            getPlanRouteProps(plan)}>{_.get(plan, 'name')}</Link></div>
          } */}
        </li>
      </ul>
      <div className="card-footer">
        <div className="row">
          <div className="col text-right">
            <Link name="home-detail" home={home}>
              View Detail<img src="/images/icon-circle-arrow-orange.svg" alt="Circle Arrow Icon" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeCard.propTypes = {
  home: PropTypes.object.isRequired,
  // community: PropTypes.object,
  // plan: PropTypes.object,
};

HomeCard.defaultProps = {
  plan: null,
  community: null,
};

export default withData(
  {
    home: true,
    // community: true,
    // plan: true,
  },
  {
    require: {
      home: true,
    },
  },
)(HomeCard);



// WEBPACK FOOTER //
// ./src/pages/HomesOriginal/HomeCard.js